if (!customElements.get('product-select')) {
  class ProductSelect extends HTMLElement {
    constructor() {
      super();

      this.handleChangeRef = this.handleChange.bind(this);
      this.handleVariantOptionChangeRef = this.handleVariantOptionChange.bind(this);
      this.handleSelectChangeRef = this.handleSelectChange.bind(this);
    }

    static get observedAttributes() { return ['data-option-1', 'data-option-2', 'data-option-3']; }

    attributeChangedCallback(name, oldValue, newValue) {
      let selector = '';

      for (let i = 1; i <= this.getAttribute('data-options-length'); i++) {
        selector += `[data-option-${i}="${this.getAttribute(`data-option-${i}`)}"]`;
      }

      const option = this.querySelector(selector);
      option.selected = true;

      this.handleChange(option)
    }

    handleChange(option) {
      this.updateURLParam(option.value);

      this.dispatchEvent(
        new CustomEvent('alexa:variant-change', {
          detail: {
            productId: this.getAttribute('data-product-id'),
            option,
            featuredMedia: this.getAttribute('data-featured-media-id'),
            variantInventoryQuantity: option.getAttribute('data-max'),
            variantInventoryPolicy: option.getAttribute('data-inventory-policy'),
          },
          bubbles: true,
        })
      );
    }

    updateURLParam(value) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      urlParams.set('variant', value);

      window.history.replaceState(null, null, window.location.pathname + '?' + urlParams.toString());
    }

    handleVariantOptionChange(event) {
      if(event.detail.productId != this.getAttribute('data-product-id')) return;

      this.setAttribute(`data-option-${event.detail.index}`, event.detail.value);
    }

    handleSelectChange(event) {
      event.target.blur();

      document.dispatchEvent(new CustomEvent('alexa:variant-change', { detail: { productId: this.getAttribute('data-product-id'), option: event.target.querySelector('option:checked') } }))
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleSelectChangeRef);
      document.removeEventListener('alexa:variant-option-change', this.handleVariantOptionChangeRef);
    }

    connectedCallback() {
      this.addEventListener('change', this.handleSelectChangeRef);
      document.addEventListener('alexa:variant-option-change', this.handleVariantOptionChangeRef);
    }
  }

  customElements.define('product-select', ProductSelect);
}
